import { put, call, takeEvery } from "redux-saga/effects";
import axios from "panel/src/services/api/api";

import * as dataActions from "panel/src/redux/actions/colors";
import * as userInfoActions from "panel/src/redux/actions/userInfo";
import * as pageActions from "panel/src/redux/actions/page";
import { SET_COLORS_START } from "panel/src/redux/constants/colors";
import { startAppLoading, endAppLoading } from "panel/src/redux/actions/App";
import { clearDesignError, setDesignError } from "../actions/DesignError";

function* setColors({ requestObj, callback }: any) {
  yield put(startAppLoading(SET_COLORS_START));
  try {
    yield put(clearDesignError());
    yield call(axios.post, "/api/Design/SetColors", { ...requestObj });

    yield put(dataActions.setColorsFinish());
    yield put(pageActions.pageUpdated(true));

    if (callback) callback?.();
  } catch (error) {
    const err = error as any;
    yield put(setDesignError(`/api/Design/SetColors - ${err?.response?.status}`));
    yield put(dataActions.setColorsRejected(err.message));
  }

  yield put(userInfoActions.getUserInfo());
  yield put(endAppLoading(SET_COLORS_START));
}

export function* setColorsSaga() {
  yield takeEvery(SET_COLORS_START, setColors);
}
